import Request from './request';

export const apiGetCsrSummary = () => {
  return Request.call({
    url: `me/csrs-summary`,
    method: 'GET',
  });
};
